import React, { PureComponent, Fragment } from 'react';
import styled, { css } from 'styled-components';
import { Accordion } from 'react-accessible-accordion';
import { Link } from 'react-router-dom';
import FAQuestion from '../landing/FAQuestion';
import Text from './Text';
import { breakpoints, palette } from '../../constants/styles';

const StyledSmallFAQ = styled.div`
  max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const questions = [
  {
    question: '¿Qué es Finauta?',
    expanded: true,
    answer: (
      <Fragment>
        <Text type="body1">
          Finauta es una empresa mexicana que tiene como fin ayudarte a lograr tus metas
          financieras. Por medio de herramientas financieras amigables y expertos certificados,
          simplificamos las finanzas personales para que tú puedas lograr tus sueños.{' '}
        </Text>
      </Fragment>
    ),
  },
];

export default class TLDRFinauta extends PureComponent {
  render() {
    return (
      <StyledSmallFAQ>
        <Accordion accordion={false} style={{ width: '100%', marginTop: '10px' }}>
          {questions.map((question) => (
            <FAQuestion question={question} key={question.question} expanded={question.expanded} />
          ))}
        </Accordion>
        {/* <Link to="/faq" style={{ alignSelf: 'flex-end', textDecoration: 'none' }}>
          <Text type="normalButton" color={palette.terciaryColor}>
            → Ver todas las preguntas frecuentes
          </Text>
        </Link> */}
      </StyledSmallFAQ>
    );
  }
}
